var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTanker = function SvgTanker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 309.333,
    height: 185.333,
    viewBox: "0 0 232 139"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 2.4C63.1 4.8 63 5.4 63 17v12h-4.3c-5.3 0-6.7 1.3-6.7 6.2V39h35v-3.8c0-5-1.4-6.2-7.2-6.2H75V16.7c0-13-.6-14.9-4.7-16.2-1.7-.4-2.9.1-4.8 1.9M29.2 60.2l.3 14.3 38.8.3 38.7.2V46H28.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 69.9c-1.1.5-3.1 3.2-4.4 6l-2.4 5.1H95.5c-62.5 0-74.4.2-76.1 1.4-1.7 1.3-1.9 2.7-1.9 11.3 0 9 .2 10.3 2.6 13.9 2.6 4 7 6.8 12.2 7.9 2.5.5 2.7.8 2.7 6v5.5h-6.8c-7.2 0-9.6 1-10.7 4.7-.4 1.7.1 2.9 1.9 4.8l2.5 2.5h187.2l2.5-2.5c1.9-1.9 2.3-3.1 1.8-4.8-1-3.5-2.1-4.1-7.7-4.7l-5.2-.5-.8-4.5c-1.5-8.9.6-16.9 9.8-36.5 5.1-10.9 5.1-13.6-.1-15.5-3-1.2-30-1.2-32.9-.1m3.9 26.4c2.1 1.6 2.4 6 .6 8.2-1.6 2-5.9 1.9-8.2-.2-5.1-4.6 2-12.1 7.6-8"
  })));
};
export default SvgTanker;